import gallery_1 from "./images/1.jpg";
import gallery_2 from "./images/2.jpg";
import gallery_3 from "./images/3.jpg";
import gallery_4 from "./images/05.jpg";

const Specs = function (props) {
  return (
    <div className="Specs" id="specs">
      <div className="title">
        The Specs <span></span>
      </div>
      <div className="content">
        <div className="content-left">
          <h3>A Neural Algorithm</h3>
          <p>
            In fine art, especially painting, humans have mastered the skill to
            create unique visual experiences through composing a complex
            interplay between the content and style of an image.
          </p>
          <p>
            A combination of the famous CryptoPunks and the astonishing Fidenza
            from Tyler Hobbs makes a perfect combination through the Neural
            Algorithm Art. No affiliations with both companies.
          </p>
          <p>
            The NeuralPunk are stored as <b>ERC-721</b> tokens on the Ethereum
            blockchain and hosted on IPFS. Purchasing an NeuralPunk costs{" "}
            <b>0.1 ETH</b>.
          </p>
          <ul className="specs-list">
            <li>Only 6942 minted</li>
            <li>Verified Smart Contract</li>
            <li>IPFS & Pinata</li>
          </ul>
        </div>
        <div className="content-right">
          <div className="content-item">
            <img src={gallery_1} alt="Mint 1#" />
          </div>
          <div className="content-item">
            <img src={gallery_3} alt="Mint 2#" />
          </div>
          <div className="content-item">
            <img src={gallery_2} alt="Mint 3#" />
          </div>
          <div className="content-item">
            <img src={gallery_4} alt="Mint 4#" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Specs;
